import React, { useState, useCallback } from 'react';
import { RadioPanelGroup, RadioPanelGroupTheme, RadioPanelBorderRadius, RadioPanelDropShadowType } from '@apply/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

export const RadioPanelGroupDemo: React.FC<{}> = ({}) => {
    const [blueRadioPanelSelections, set_blueRadioPanelSelections] = useState(['3']);
    const [redRadioPanelSelections, set_redRadioPanelSelections] = useState(['3']);
    const [grayRadioPanelSelections, set_grayRadioPanelSelections] = useState(['3']);
    const [blueWrapRadioPanelSelections, set_blueWrapRadioPanelSelections] = useState(['3']);
    const [blueMultiSelectRadioPanelSelections, set_blueMultiSelectRadioPanelSelections] = useState(['3']);
    const [blueMultiSelectMaxLengthRadioPanelSelections, set_blueMultiSelectMaxLengthpRadioPanelSelections] = useState(['3']);

    const panelItemClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    const handleDeleteClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    const renderOption = (id: string, address: string, details: string, showIcon: boolean) => {
        return (
            <>
                <div className='item'>
                    <div className='itemContent'>
                        <div className='itemTitle'>{address}</div>
                        <div className='itemSubtitle'>{details}</div>
                    </div>
                    {showIcon && (
                        <div
                            id={`deleteOption_${id}`}
                            className='itemTrash'
                            onClick={handleDeleteClick}
                        >
                            <FontAwesomeIcon
                                color='red'
                                fontSize='20px'
                                icon={faTrashCan}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    };

    //Handle Clicks can be commented in and wired to show events.
    const radioOptions = [
        {
            id: '1',
            children: renderOption('1', 'Arlington Developments', '$190,990 + Land', false),
            handleClick: panelItemClick,
        },
        {
            id: '2',
            children: renderOption('2', '1234 Commerce St Testville', '$175,000 + Land', true),
            // handleClick: panelItemClick,
        },
        {
            id: '3',
            children: renderOption('3', '8499 Sussex St, Windsor', '$240,990 + Land', false),
            // handleClick: panelItemClick,
        },
        {
            id: '4',
            children: renderOption('4', '1234 Commerce St Testville', '$175,000 + Land', false),
            // handleClick: panelItemClick,
        },
        {
            id: '5',
            children: renderOption('5', '8499 Sussex Ct, Windsor', '$240,990 + Land', false),
            // handleClick: panelItemClick,
        },
    ];

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px', padding: '0px 20px 0px 0px' }}>
            <h2>Radio Panel Group :</h2>
            <br />
            Blue Theme
            <br />
            <br />
            <RadioPanelGroup
                id='blueRPDemo'
                items={radioOptions}
                theme={RadioPanelGroupTheme.Blue}
                selectedPanels={blueRadioPanelSelections}
                set_selectedPanels={set_blueRadioPanelSelections}
                borderRadius={RadioPanelBorderRadius.Small}
                dropShadowType={RadioPanelDropShadowType.Small}
            />
            <br />
            Red Theme
            <br />
            <br />
            <RadioPanelGroup
                id='redRPDemo'
                items={radioOptions}
                theme={RadioPanelGroupTheme.Red}
                selectedPanels={redRadioPanelSelections}
                set_selectedPanels={set_redRadioPanelSelections}
                borderRadius={RadioPanelBorderRadius.Small}
                dropShadowType={RadioPanelDropShadowType.Small}
            />
            <br />
            Grey Theme
            <br />
            <br />
            <RadioPanelGroup
                id='greyRPDemo'
                items={radioOptions}
                theme={RadioPanelGroupTheme.Gray}
                selectedPanels={grayRadioPanelSelections}
                set_selectedPanels={set_grayRadioPanelSelections}
                borderRadius={RadioPanelBorderRadius.Small}
                dropShadowType={RadioPanelDropShadowType.Small}
            />
            <br />
            Blue Theme (Wrapped Example)
            <br />
            <br />
            <RadioPanelGroup
                id='bluewrappedRPDemo'
                items={radioOptions}
                theme={RadioPanelGroupTheme.Blue}
                selectedPanels={blueWrapRadioPanelSelections}
                set_selectedPanels={set_blueWrapRadioPanelSelections}
                borderRadius={RadioPanelBorderRadius.Small}
                dropShadowType={RadioPanelDropShadowType.Small}
                wrapPanels={true}
                panelWidth='260px'
            />
            <br />
            <br />
            Blue Theme (Multiselect)
            <br />
            <br />
            <RadioPanelGroup
                id='bluemultiselectRPDemo'
                items={radioOptions}
                theme={RadioPanelGroupTheme.Blue}
                selectedPanels={blueMultiSelectRadioPanelSelections}
                set_selectedPanels={set_blueMultiSelectRadioPanelSelections}
                borderRadius={RadioPanelBorderRadius.Small}
                dropShadowType={RadioPanelDropShadowType.Small}
                selectionType='multiple'
            />
            <br />
            <br />
            Blue Theme (Multiselect - Max 3)
            <br />
            <br />
            <RadioPanelGroup
                id='bluemultiselectWithMaxRPDemo'
                items={radioOptions}
                theme={RadioPanelGroupTheme.Blue}
                selectedPanels={blueMultiSelectMaxLengthRadioPanelSelections}
                set_selectedPanels={set_blueMultiSelectMaxLengthpRadioPanelSelections}
                borderRadius={RadioPanelBorderRadius.Small}
                dropShadowType={RadioPanelDropShadowType.Small}
                selectionType='multiple'
                maxSelection={3}
            />
            <br />
        </div>
    );
};
